module.exports = __webpack_public_path__ + "static/1-bedd391b0468cc4385f8574744deb55e.jpg";